import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  registerSentenceCase: {
    id: 'general.register.sentenceCase',
    defaultMessage: 'ลงทะเบียน',
    description: 'Text in a button, prompting the user to register.',
  },
  signInSentenceCase: {
    id: 'general.signIn.sentenceCase',
    defaultMessage: 'เข้าสู่ระบบ',
    description: 'Text in a button, prompting the user to log in.',
  },
});

export default messages;
